import React from 'react';
import './textEditorButton.styles.scss';
import Button from '../button/Button';

interface TextEditorButtonProps {
    icon: string;
    onClick: () => void;
    isActive?: boolean;
}

function TextEditorButton({icon, onClick, isActive}: TextEditorButtonProps): JSX.Element {
    return (
        <Button
            leading={icon}
            size="sm"
            square
            variant={isActive ? 'soft' : 'ghost'}
            color={isActive ? 'secondary' : 'primary'}
            onClick={onClick}
        />
    );
}

export default TextEditorButton;
